import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import LeadPhoneCall, {
  leadPhoneCallColors,
  leadPhoneCallDesigns,
  leadPhoneCallSizes,
  leadPhoneCallTarget,
  leadPhoneCallType
} from '@adv-mt/mt-lead-phone-call'

import {useContactCardState, useContactSellerV2Config} from '../context/ContactSellerV2Context.js'
import usePhoneReveal from '../hooks/usePhoneReveal.js'

const BASE_CLASS = 'mt-ContactCardV2-phoneAction'

const NO_OP = () => {}

const phoneActionPropTypes = {
  iconOnlyCapable: PropTypes.bool,
  color: PropTypes.oneOf(Object.values(leadPhoneCallColors)),
  design: PropTypes.oneOf(Object.values(leadPhoneCallDesigns)),
  isInDrawer: PropTypes.bool
}

const PhoneActionButton = ({
  color = leadPhoneCallColors.PRIMARY,
  design = leadPhoneCallDesigns.OUTLINE,
  iconOnlyCapable = false,
  isInDrawer = false,
  phone
}) => {
  const {
    target,
    adId,
    authenticationHitInformation2,
    contractId,
    extendedLeadTrackingData,
    hasCriteoEvents = false,
    multiprovince,
    onLeadPhoneCall = NO_OP,
    underlineRevealedPhone = false
  } = useContactSellerV2Config()
  const buyerIntentionsSelection = useContactCardState({optional: true})?.buyerIntentionsSelection
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const {HIT_ORIGINS} = config.get('tracking')
  const phoneViewedHitOrigin = isInDrawer ? HIT_ORIGINS.DETAIL_DRAWER : HIT_ORIGINS.DETAIL_PAGE

  const {revealedPhone, rememberRevealedPhone} = usePhoneReveal({adId})
  const hasFinancingIntention = Boolean(buyerIntentionsSelection?.hasFinancingIntention)

  return (
    <div className={cx(BASE_CLASS, {[`${BASE_CLASS}--iconOnly`]: iconOnlyCapable})}>
      <LeadPhoneCall
        adId={adId}
        authenticationHitInformation2={authenticationHitInformation2}
        color={color}
        contractId={contractId}
        design={design}
        extendedLeadTrackingData={extendedLeadTrackingData}
        hasCriteoEvents={hasCriteoEvents}
        isFullWidth
        multiprovince={multiprovince}
        onLeadPhoneCall={onLeadPhoneCall}
        onPhoneRevealed={rememberRevealedPhone}
        phone={phone}
        phoneViewedHitOrigin={phoneViewedHitOrigin}
        revealedPhone={revealedPhone}
        size={leadPhoneCallSizes.large}
        target={hasFinancingIntention ? leadPhoneCallTarget.financingDealer : target}
        type={leadPhoneCallType.button}
        underlineRevealedPhone={underlineRevealedPhone}
      />
    </div>
  )
}

PhoneActionButton.displayName = 'PhoneActionButton'
PhoneActionButton.propTypes = {...phoneActionPropTypes, phone: PropTypes.string}

const PhoneAction = ({color, design, iconOnlyCapable, isInDrawer}) => {
  const {phone = '', hidePhone = false} = useContactSellerV2Config()

  if (hidePhone) return null

  return (
    <PhoneActionButton
      color={color}
      design={design}
      iconOnlyCapable={iconOnlyCapable}
      isInDrawer={isInDrawer}
      phone={phone}
    />
  )
}

PhoneAction.displayName = 'PhoneAction'
PhoneAction.propTypes = phoneActionPropTypes

export default PhoneAction
